/**
 * Each lab's one icon, by name.
 *
 * Every surface that shows a lab — the student Labs page, zitmus's nav and
 * catalogue cards, the teacher chapter view, the benches' own titles — draws it
 * from here, so a lab looks the same wherever it is offered. The drawings live
 * beside their benches; this is the one place that says which is whose.
 */
import { BenchMark } from '../chemistry-lab/components/BenchMark';
import { MechanicsMark } from '../mechanics-bench/MechanicsMark';
import { OpticsMark } from '../optics-bench/OpticsMark';
import { SimulationsMark } from '../simulations/SimulationsMark';
import type { LabMarkId } from './types';

export type { LabMarkId } from './types';

const MARKS = {
  chemistry: BenchMark,
  mechanics: MechanicsMark,
  optics: OpticsMark,
  simulations: SimulationsMark,
} satisfies Record<LabMarkId, unknown>;

export function LabMark({ lab, size, className }: { lab: LabMarkId; size?: number; className?: string }): React.JSX.Element {
  const Mark = MARKS[lab];
  return <Mark size={size} className={className} />;
}
